import {
    headerFunc
} from "./common/_header";
import {
    commonFunc
} from "./common/_common";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
});

document.addEventListener('DOMContentLoaded', () => {
  commonFunc();
});